export const CORPORATE_TEAM = {
  AGREEMENT_AND_ONBOARDING: 1,
  COMPLIANCE: 2,
  MARKETING: 3,
  STATE_TEAM: 4,
  P_AND_P: 5,
  WEALTH_MARKET_CORPORATE: 6,
  BROKER_SUPPORT: 7,
  IT_SUPPORT: 8,
  ACCREDITATIONS: 9,
  ID_CORPORATE: 10,
  NZ_CORPORATE: 11,
  SUPER_ADMIN: 12,
  FINANCE: 13,
  FST: 14,
  COMMISSION: 15,
};
